import React, { FC, ReactElement } from 'react';

import styles from './companyChartStyles.scss';

import CompanyPoll from 'buyside/components/presentation/CompanyPoll/companyPoll';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import { CompanyQuestion } from 'buyside/components/container/CompanyShow/BuysideConsensusContainer';

import { noop } from 'buyside/util/lodashAlt';

import RightArrow from 'buyside/svgs/right_arrow.svg';

const BuysideConsensusMain: FC<{
  companyQuestions: (CompanyQuestion | null)[];
  handleAnswer: (id: string, answers: string[]) => void;
  handleSkip: (id: string) => void;
  activeIdx: number;
  toggleMainArea: (boolean: boolean) => void;
}> = ({ companyQuestions, handleAnswer, handleSkip, activeIdx, toggleMainArea }): ReactElement => {
  const questionId = companyQuestions.at(activeIdx)?.id;
  return (
    <div className={styles.priceChartWrapper}>
      <div className={styles.pollResultsWrap}>
        <CompanyPoll
          question={companyQuestions[activeIdx]}
          answerPoll={handleAnswer}
          toggleMainArea={toggleMainArea}
          skipPoll={questionId ? (): void => handleSkip(questionId) : noop}
        />
        <Button
          id="skip-button"
          onClick={
            questionId
              ? (): void => {
                  handleSkip(questionId);
                }
              : noop
          }
          className={styles.browseButton}
          type={BUTTON_TYPES.LINK}
          icon={RightArrow}
          iconStyle={styles.browseIcon}
          analyticsTag={`buyside-poll-right-arrow-skip-${questionId}`}
        />
      </div>
    </div>
  );
};

export default BuysideConsensusMain;
